/**
 * Normalizes source repo into `https://github.com/<org>/<repo>` form
 */
function githubRepoURL(source) {
    if (!source) {
        return undefined;
    }
    const repo = source
        .trim()
        .replace(/^git\+/, "")
        .replace(/^git@github\.com:/, "https://github.com/")
        .replace(/^ssh:\/\/git@github\.com\//, "https://github.com/")
        .replace(/\.git$/, "")
        .replace(/\/+$/, "");
    return repo || undefined;
}
export function githubRepoName(meta) {
    const repo = githubRepoURL(meta.source);
    return repo?.split("/").pop();
}
export function githubSourceURL(meta) {
    const repo = githubRepoURL(meta.source);
    if (!repo) {
        return undefined;
    }
    return meta.revision ? `${repo}/tree/${meta.revision}` : repo;
}
